export enum EInboundStatus {
  OPEN = 1,
  PARTIAL = 2,
  COMPLETED = 3,
  VOID = 4,
  ERROR = 5,
  SEND = 6,
  SEND_ERROR = 7,
  PENDING = 8,
}
export enum EInboundType {
  NORMAL = 1,
  RETURN = 2,
}
